import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  Output
} from '@angular/core';

@Directive({
  selector: '[idpClickOutside]',
  standalone: true
})
export class ClickOutsideDirective implements AfterViewInit {
  private hostEl = inject(ElementRef<HTMLElement>);

  @Output() appClickOutside = new EventEmitter<{ id: string }>();
  @Input() isMobile = false;
  @Input() APP_DISABLE_LEGACY = true;

  @HostListener('document:click', ['$event.target'])
  onClick(targetElement: EventTarget | null): void {
    if (!this.isValidClick(targetElement)) return;
    if (this.APP_DISABLE_LEGACY) return;
    if (this.isClickInsideNav(targetElement as HTMLElement)) return;
    this.appClickOutside.emit({ id: '' });
  }

  private isClickInsideNav(element: HTMLElement): boolean {
    return (
      this.hostEl.nativeElement.contains(element) || this.isOverlay(element)
    );
  }

  private isOverlay(element: HTMLElement): boolean {
    return (
      !!element.closest('#airport-search-modal-container') ||
      !!element.closest('idp-airport-dropdown-modal') ||
      !!element.closest('[id$="-search-transparent"]') ||
      !!element.closest('[id$="-search"]')
    );
  }

  ngAfterViewInit(): void {
    this.checkAppDisabledLegacy();
  }

  checkAppDisabledLegacy(): void {
    if (this.APP_DISABLE_LEGACY) {
      this.appClickOutside.emit({ id: 'book' });
    } else {
      this.appClickOutside.emit({ id: '' });
    }
  }

  private isValidClick(targetElement: EventTarget | null): boolean {
    return (
      !!targetElement && targetElement instanceof HTMLElement && !this.isMobile
    );
  }
}
